export const apiEndPointConstant = {
  authClient: "/client/auth",
  client: "/client"
};
